import {useState, useCallback} from 'react';

export interface CategoryStat {
    id: number;
    name: string;
    count: number;
}

export interface TagStat {
    id: number;
    name: string;
    count: number;
}

export interface AuthorStats {
    categories: CategoryStat[]
    tags: TagStat[]
    total_posts: number;
    total_authors: number;
    author_posts: number;
}

interface useGetAuthorStatsResult {
    getAuthorStats: (userId: number) => Promise<AuthorStats | null>;
    isLoading: boolean;
    error: string | null;
    data: AuthorStats | null;
}

const useGetAuthorStats = (): useGetAuthorStatsResult => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [data, setData] = useState<AuthorStats | null>(null);

    const getAuthorStats = useCallback(async (userId: number) => {
        setIsLoading(true);
        setError(null);

        try {
            const apiUrl = process.env.REACT_APP_API_BASE || '/api';
            const response = await fetch(`${apiUrl}/user/stats/${userId}`, {
                method: 'GET',
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
            }

            const result = await response.json();
            setData(result);
            return result;
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Неизвестная ошибка';
            setError(errorMessage);
            throw err;
        } finally {
            setIsLoading(false);
        }
    }, []);

    return {getAuthorStats, isLoading, error, data};
};

export default useGetAuthorStats;